<style scoped>
</style>

<script>
import "bootstrap-touchspin";
import "bootstrap-touchspin/dist/jquery.bootstrap-touchspin.min.css";

export default {
	components: {},
	props: {
		value : {
			type : Number,
			required : true,
		},
		dataStep : {
			type : String,
			required : false,
			default : '0.1'
		},
		dataDecimals : {
			type : String,
			required : false,
			default : '1'
		},
		dataBtsPostfix : {
			type : String,
			required : false,
			default : ''
		},
	},
	data() {
		return {
			id : `touchspin_${Math.floor(new Date().getTime() / 1000 * Math.random())}`
		}
	},
	mounted() {
		window.$(`#${this.id}`).TouchSpin({
    	// min: 0,
    	// max: 100,
    	// step: 0.1,
    	// decimals: 2,
    	// boostat: 5,
    	// maxboostedstep: 10,
			// postfix: '%'
    }).on('touchspin.on.stopspin', (e) => {
			this.onChange(e);
		});

	},
	updated() {

	},
	methods : {
		onChange(e) {
			// this.props.onChange && this.props.onChange(e);
			this.$emit('input', Number(e.target.value));
		}

	},

}
</script>

<template>
	<input
		:id="id"
		data-width="50"
		data-toggle="touchspin"
		type="text"
		:value="value"
		:data-step="dataStep"
		:data-decimals="dataDecimals"
		:data-bts-postfix="dataBtsPostfix"
	/>
		<!-- @change="change" -->
</template>
